import axios from "axios"; // Importa Axios
import React, { useEffect, useState } from "react";
import MapGoogle from "./MapGoogle"; // Asegúrate de que la ruta sea correcta
import ModalBootstrap from "../modal/ModalBootstrap";
import { mostraAlertaError, mostraAlertaOk } from "../alerts/sweetAlert";


const GestionUbicacion = ({
    direccion,
    setDireccion,
    isModalOpen,
    setIsModalOpen,
    setSeleccionarDireccion,
    verdireccion,
    textoBoton
}) => {
    const apiKey = "AIzaSyCGXF5gopo3pYCSblAPuGRBYUB54BTSQos"; // Reemplaza con tu API Key de Google Maps
    
    const requestGeolocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                async ({ coords }) => {
                    const { latitude, longitude } = coords;
                    const direccion = await obtenerDireccion(latitude, longitude);
                    const nuevaDireccion = {
                        direccion: direccion || "",
                        latitud: latitude.toFixed(4).toString(),
                        longitud: longitude.toFixed(4).toString(),
                    };
                    setDireccion(nuevaDireccion);
                    updateCenter(nuevaDireccion);
                },
                (error) => {
                    console.error("Error obteniendo la ubicación", error);
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            mostraAlertaError("El usuario negó el permiso de geolocalización.", "error");
                            break;
                        case error.POSITION_UNAVAILABLE:
                            mostraAlertaError("La ubicación no está disponible.", "error");
                            break;
                        case error.TIMEOUT:
                            mostraAlertaError("La solicitud de geolocalización agotó el tiempo.", "error");
                            break;
                        default:
                            mostraAlertaError("Ocurrió un error desconocido.", "error");
                            break;
                    }
                }
            );
        } else {
            alert("Geolocalización no está soportada por este navegador.");
        }
    };

    const obtenerDireccion = async (lat, lng) => {
        try {
            const response = await axios.get(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`
            );
            const addressComponents =
                response.data.results[0]?.address_components || [];
            const formattedAddress = addressComponents
                .map((component) => component.long_name)
                .join(", ");
            return formattedAddress || "Dirección no encontrada";
        } catch (error) {
            console.error("Error al obtener la dirección:", error);
            return "Error obteniendo la dirección";
        }
    };

    const handleMapClick = (lat, lng, direccion) => {
        const nuevaDireccion = {
            direccion: direccion || "",
            latitud: lat.toFixed(4).toString(),
            longitud: lng.toFixed(4).toString(),
        };
        setDireccion(nuevaDireccion);
    };

    const agregarDireccion = () => setSeleccionarDireccion(true);

    const [mapCenter, setMapCenter] = useState({
        lat: parseFloat(direccion?.latitud) || 14.1,
        lng: parseFloat(direccion?.longitud) || -87.21,
    });

    const updateCenter = (direccion) => {
        setMapCenter({
            lat: parseFloat(direccion.latitud),
            lng: parseFloat(direccion.longitud),
        });
    };
    const BotonUbicacionActual = () => {
        return (
            <>
                <button type="button" className="btn btn-info" onClick={agregarDireccion}>
                    Seleccionar
                    <i className="fas fa-map-marker-alt mr-1 mx-2" />
                </button>
                <button type="button" className="btn btn-info" onClick={requestGeolocation}>
                    Ubicar
                    <i className="fas fa-mobile-alt mx-2" />
                </button>
            </>
        )
    }

    return (
        <>
            <ModalBootstrap
                titulo={"Seleccionar Ubicación"}
                nombreBoton={textoBoton}
                estiloBoton={"btn btn-primary"}
                iconBoton={"fas fa-map-marker-alt mr-1"}
                pie={ verdireccion ? "" : <BotonUbicacionActual />}
                modalIsOpen={isModalOpen}
                setModalIsOpen={setIsModalOpen}
            >
                <MapGoogle
                    center={mapCenter}
                    zoom={9}
                    onMapClick={handleMapClick}
                    apiKey={apiKey}
                />
                <div className="card-body">
                    <strong><i className="fas fa-map-marker-alt mr-1" /> Direccion</strong>
                    
                        <textarea
                            type="text"
                            className="form-control"
                            placeholder="Busque la dirección"
                            name="direccion"
                            rows="3"
                            value={direccion.direccion}
                            onChange={(event) =>
                                setDireccion((prevState) => ({
                                    ...prevState,
                                    direccion: event.target.value,
                                }))
                            }
                        />
                </div>
            </ModalBootstrap>
        </>
    );
};

export default GestionUbicacion;